module.exports = __webpack_public_path__ + "static/p1-23813d31140ae0511a1dc8dbee22a1b1.png";